
import React from "react";
import Fform from './Components/Fform';
const app = () => {
return(
  <>
  <Fform/>
  </>
)

}
export default app
